<div
  data-test="Gq3p3Mxb"
  class="login__form"
  *ngIf="resetPasswordForm$ | async | notNull as resetPasswordForm"
>
  <div data-test="52JR2dos" class="login__form-header">
    <h1 data-test="U5_mySjx">Reset password</h1>
  </div>
  <form
    data-test="hqHMoPOP"
    class="form"
    [ngrxFormState]="resetPasswordForm"
    (submit)="resetPassword()"
  >
    <div
      data-test="Ti2ZLKxg"
      class="form-group"
      [class.error]="
        resetPasswordForm.controls.password.isInvalid &&
        resetPasswordForm.controls.password.isDirty
      "
    >
      <label data-test="XH69_0as" class="form-group__label" for="input-1">
        New password
        <span data-test="1aaAYZZc" style="color: #78909c; font-weight: 400">
          (at least 8 symbols)
        </span>
      </label>
      <input
        data-test="zau8xvR3"
        class="input"
        id="input-1"
        type="password"
        placeholder="Enter new password..."
        [ngrxFormControlState]="resetPasswordForm.controls.password"
      />
    </div>
    <div
      data-test="EpWi0FJg"
      class="form-group"
      [class.error]="resetPasswordForm.controls.confirmPassword.isInvalid"
    >
      <label data-test="JX3D7QCF" class="form-group__label" for="input-2">
        Confirm password
      </label>
      <input
        data-test="8hJBUF-r"
        class="input"
        id="input-2"
        type="password"
        placeholder="Enter confirm password..."
        [ngrxFormControlState]="resetPasswordForm.controls.confirmPassword"
      />
    </div>
    <div data-test="4wzlKt2S" class="form-group">
      <button
        data-test="HmVeT_s3"
        class="form-submit button button_primary w-100"
        type="submit"
        [disabled]="resetPasswordForm.isInvalid"
      >
        Confirm
      </button>
    </div>
  </form>
</div>
